import React from 'react';
import {Typography} from "@bonprix/design-system";


export default function PriceReduction({ priceReductionCampaign }) {

    const isValidPriceReductionCampaign = priceReductionCampaign
        && priceReductionCampaign?.backgroundColor?.length > 0
        && priceReductionCampaign?.color?.length > 0
        && priceReductionCampaign?.text?.length > 0;

    if (isValidPriceReductionCampaign) {
        return (
            <div style={{
                width: '100%',
                padding: '0.25rem 0.5rem',
                backgroundColor: priceReductionCampaign.backgroundColor,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
            }}>
                <Typography color={priceReductionCampaign.color} variant="bonprix-h6" component={'center'}>{priceReductionCampaign.text}</Typography>
            </div>
        );
    }
    return null;
}